import { movies } from "@/mocks/catalog";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

const traits = ["职场日常", "邻里群像", "小人物公路", "误会与巧合", "暖心收尾"];

export default function ComedySection() {
  const items = movies.filter((m) => m.genre === "喜剧片");

  return (
    <section id="comedy" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="喜剧片专区"
            title="喜剧片：笑点来自生活里的错位"
            description="好的喜剧往往从一个很小的误会开始，让人物在各自的立场里越走越远，又在结尾处轻轻和解。适合下班后和家人朋友一起放松观看。"
          />
          <div className="flex flex-wrap gap-2 md:justify-end">
            {traits.map((t) => (
              <span
                key={t}
                className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900"
              >
                {t}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}